export default __webpack_public_path__ + "static/media/img-press-release-ovato-lists-new.db8ea808.jpg";